import { render, staticRenderFns } from "./component-a8fee867.vue?vue&type=template&id=d1131db2&scoped=true&"
import script from "./component-a8fee867.vue?vue&type=script&lang=js&"
export * from "./component-a8fee867.vue?vue&type=script&lang=js&"
import style0 from "./component-a8fee867.vue?vue&type=style&index=0&id=d1131db2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1131db2",
  null
  
)

export default component.exports